/**
 * Testimonial carousel — one quote at a time, advanced by the arrow controls.
 * Slides are shown and hidden with the `hidden` attribute so hidden quotes stay
 * out of the accessibility tree and out of the tab order.
 */
class TestimonialCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.counter = this.querySelector('[data-current]');
    this.index = 0;

    if (this.slides.length < 2) return;

    this.querySelectorAll('[data-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        this.go(button.dataset.direction === 'next' ? 1 : -1);
      });
    });
  }

  go(step) {
    const count = this.slides.length;
    // Wrap in both directions so the arrows never dead-end.
    this.index = (this.index + step + count) % count;

    this.slides.forEach((slide, i) => {
      slide.toggleAttribute('hidden', i !== this.index);
    });

    if (this.counter) this.counter.textContent = String(this.index + 1);
  }
}

customElements.define('testimonial-carousel', TestimonialCarousel);
